import { StyledTag } from './AverageScore.styles';

type Props = {
  averageScore: number;
  placeHolder?: string;
};

export const AverageScore: React.FC<Props> = ({ averageScore, placeHolder }) => {
  return (
    <StyledTag score={averageScore}>
      {averageScore ? averageScore.toFixed(1) : placeHolder ?? '-'}
    </StyledTag>
  );
};
